const typography = {
    fontFamily: 'Mulish',
    color: 'success.dark'
}

export default typography